import { createStorage } from '@aviata/storage';

export const withTheme = () => {
  /**
   * @description Native app sends malformed query parameters with double
   * question marks. This is a temporary workaround until the bank fixes the
   * issue on their side. Valid URLs are processed properly.
   */
  const { search } = window.location;
  const hasMultipleQuestionMarks = (search.match(/\?/g) || []).length > 1;
  let rawQuery = search.slice(1); // remove the leading question mark

  if (hasMultipleQuestionMarks) {
    // Replace '?' with '&'
    rawQuery = rawQuery.replace(/\?(?=[^?]*$)/, '&');
  }

  const params = new URLSearchParams(rawQuery);
  const storage = createStorage(localStorage);
  const defaultTheme = 'light';
  const themeFromParams = params.get('theme');
  const theme = themeFromParams || storage.get('theme') || defaultTheme;

  if (theme === 'dark' || theme === 'light') {
    if (themeFromParams) {
      storage.set('theme', theme);
    }
    document.documentElement.classList.toggle('dark', theme === 'dark');
  }
};
